import { FC } from 'react';
import { classSet, Table as LibraryTable } from '@platform/ui-library';
import { TabsTypeProps } from '@platform/ui-library/build/Table/types';
import styles from './Table.module.scss';

type TableProps = (
  TabsTypeProps
  & {
    /**
     * @asTable Indicates if the table divs should be styled as a HTML table.
     * If no className is provided, it will use a table-layout: fixed
     * (all columns have the same width).
     */
    asTable?: boolean;
    className?: string;
  }
);

export const Table: FC<TableProps> = ({
  asTable,
  className,
  ...tableProps
}) => {
  return (
    <LibraryTable
      theme={{
        table: classSet([styles.table, asTable && styles.asTable, className ?? (asTable && 'layout-fixed')]),
        thead: styles.thead,
        tbody: styles.tbody
      }}
      { ...tableProps }
    />
  );
};
